$(document).ready(function() {

  // add classes to header-logo
  const $body = $('body');
  const subpageThemes = [
    'subpage-theme--catering',
    'subpage-theme--fair-rodeo',
    'subpage-theme--first-interstate',
    'subpage-theme--rv-park'
  ];

  const bodyClasses = document.body.classList;
  let onSubpageThemePage = false;

  subpageThemes.forEach((theme, i) => {
    // console.log(theme)
    if (bodyClasses.contains(theme)) {
      onSubpageThemePage = true;
      $('.header-logo').addClass(`logo${theme.substring(14)}`);
    }
  });
  
  if (!onSubpageThemePage) {
    $('.header-logo').addClass('logo-expo-center');
  }


  // prepend general message to header
  $('.generalmessage').prependTo('.header');

    // Custom Header Search Functionality
    const nav = $('#mainNavigation');

    function handleSearch() {
      const input = $('.customSearch__input');
      const value = input.val();
      if (value !== '') { 
        $('.searchBox .inputFieldTextbox').val(value);
        $('.searchBox .searchSubmitButton').click();
      } else {
        return false;
      }
    }
  
    $('.customSearch').on('click keypress', function(e) {
      e.preventDefault();
      if (e.key === 'Enter' || e.type === 'click') {
        const wrapper = $('.customSearch-wrapper');
        if (!wrapper.hasClass('search-active')) {
          // nav.fadeOut('fast');
          wrapper.fadeOut('fast', function() {
            wrapper.addClass('search-active');
            wrapper.fadeIn('fast', function() {
              $('.customSearch__input').focus();
            });
          })
        } else {
          handleSearch();
        }
      }
    });
  
    $('.customSearch__input').on('keypress', function(e) {
      if (e.key === 'Enter') {
        handleSearch();
      }
    });
  
    $('.customSearch__close').on('click keypress', function(e) {
      const wrapper = $('.customSearch-wrapper');
      wrapper.fadeOut('fast', function() {
        wrapper.removeClass('search-active');
        wrapper.fadeIn('fast');
        // nav.fadeIn('fast');
      });
    });
    // ---

    // Email Signup changes
    $('.homepage .emailSignupText').html('<span>Updates & Deals</span> Sign up for our e-newsletter!');
    $('.homepage .emailSubmitButton').text('Subscribe');
    $('.homepage .emailInputField .inputFieldTextbox').val('');
    $('.homepage .emailInputField .inputFieldTextbox').attr('placeholder', 'Email Address');

    // Update footer saffire logo
    $('.footer .saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffireFooter-logo.png`);

	// $('.subpage-theme--first-interstate #MainContent_content_smp_breadcrumbs').appendTo('.imageModule-slideshow.module');
	// $('.subpage-theme--fair-rodeo #MainContent_content_smp_breadcrumbs').appendTo('.imageModule-slideshow.module'); 
	
	$('.subpage-theme--fair-rodeo .afterContent #fairSwiper').prependTo('.subpage-theme--fair-rodeo .content');
	$('.subpage-theme--first-interstate .afterContent #interStateSwiper').prependTo('.subpage-theme--first-interstate .content');
	

});

$(window).load(function() {
  $('.footer .footerItems1 a').removeClass('button');
	$('#interStateSwiper a[href="null"]').attr('href', 'javascript:void(0)');
	$('#fairSwiper a[href="null"]').attr('href', 'javascript:void(0)');
	
  // Weather Bug
  setInterval(function() {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if(!weatherBugSet && str != ''){
      $('#weatherBugWidget').addClass('weatherBugSet');
        var findSpace = str.lastIndexOf(' ');
        var stringLength = str.length;
        var res = str.substring(findSpace, stringLength);
        var start = str.substring(0, findSpace);
        $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
        $('#weatherBugWidget').css('visibility', 'visible');
    }
  },12);
});

$(window).resize(function() {
  $('.footer .footerItems1 a').removeClass('button');
})